import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 400,
    bgcolor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.14)",
    p: "32px",
    outline: "none",
    textAlign: "center",
};

export function GlobalSuccessModal({ open, handleClose, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#e8f5e9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <CheckCircleOutlineIcon sx={{ color: "#4caf50", fontSize: 32 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        if (handleDismiss) handleDismiss();
                    }}
                    sx={{
                        backgroundColor: "#ff3b1d",
                        borderRadius: "999px",
                        px: 5,
                        py: 1,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "15px",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </Box>
        </Modal>
    );
}

export default GlobalSuccessModal;

export function GlobalErrorModal({ open, handleClose, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#ffebee",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <HighlightOffIcon sx={{ color: "#f44336", fontSize: 36 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        if (handleDismiss) handleDismiss();
                    }}
                    sx={{
                        backgroundColor: "#ff3b1d",
                        borderRadius: "999px",
                        px: 5,
                        py: 1,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "15px",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </Box>
        </Modal>
    );
}

export function GlobalWarningGlobal({ open, handleClose, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#fff8e1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <WarningAmberRoundedIcon sx={{ color: "#ff9800", fontSize: 36 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        if (handleDismiss) handleDismiss();
                    }}
                    sx={{
                        backgroundColor: "#ff3b1d",
                        borderRadius: "999px",
                        px: 5,
                        py: 1,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "15px",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </Box>
        </Modal>
    );
}

export function GlobalConfirmModal({ open, handleClose, handleConfirm, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#fff8e1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <WarningAmberRoundedIcon sx={{ color: "#ff9800", fontSize: 36 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title || "Deseja mesmo excluir?"}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={(e) => {
                            if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                            if (handleDismiss) handleDismiss();
                        }}
                        sx={{
                            borderColor: "#cccccc",
                            color: "#666666",
                            borderRadius: "999px",
                            px: 4,
                            py: 1,
                            fontWeight: 700,
                            textTransform: "none",
                            fontSize: "15px",
                            "&:hover": { borderColor: "#999999", backgroundColor: "#f5f5f5" },
                        }}
                    >
                        Não
                    </Button>
                    <Button
                        variant="contained"
                        onClick={(e) => {
                            if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                            if (handleConfirm) handleConfirm();
                        }}
                        sx={{
                            backgroundColor: "#ff3b1d",
                            borderRadius: "999px",
                            px: 4,
                            py: 1,
                            fontWeight: 700,
                            textTransform: "none",
                            fontSize: "15px",
                            boxShadow: "none",
                            "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                        }}
                    >
                        Sim
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export function GlobalRequiredFieldsModal({
    open,
    handleClose,
    title = "Campos obrigatórios faltando",
    subtitle = "Os seguintes campos obrigatórios estão vazios:",
    messages = [],
    show,
    onClose
}) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;
    const messageList = Array.isArray(messages) ? messages : [];

    return (
        <Dialog
            open={isVisible}
            onClose={handleDismiss}
            maxWidth={false}
            scroll="paper"
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(1, 36, 67, 0.48)",
                        backdropFilter: "blur(4px)",
                        WebkitBackdropFilter: "blur(4px)",
                    }
                }
            }}
            PaperProps={{
                style: {
                    width: "100%",
                    maxWidth: "520px",
                    borderRadius: "16px",
                    padding: "0",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0 18px 40px rgba(1, 36, 67, 0.18)",
                }
            }}
        >
            <Box
                sx={{
                    backgroundColor: "rgba(255, 49, 0, 0.10)",
                    p: { xs: 2, sm: 2.5 },
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    borderBottom: "1px solid rgba(1, 36, 67, 0.12)"
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        backgroundColor: "#FFFFFF",
                        border: "1px solid rgba(1, 36, 67, 0.12)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 12px rgba(1, 36, 67, 0.08)",
                        flexShrink: 0
                    }}
                >
                    <WarningAmberRoundedIcon sx={{ fontSize: 26, color: "#FF3100" }} />
                </Box>
                <Box textAlign="left">
                    <Typography
                        variant="h6"
                        fontWeight={700}
                        color="#012443"
                        sx={{ lineHeight: 1.3, fontSize: { xs: "1.05rem", sm: "1.2rem" } }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="rgba(30, 33, 36, 0.72)"
                        sx={{ mt: 0.5, fontSize: "0.9375rem", lineHeight: 1.4 }}
                    >
                        {subtitle}
                    </Typography>
                </Box>
            </Box>

            <DialogContent
                sx={{
                    px: { xs: 2, sm: 2.5 },
                    py: { xs: 1.75, sm: 2 },
                    overflowY: "auto",
                    maxHeight: { xs: "42vh", sm: "46vh" },
                }}
            >
                <Stack
                    spacing={1.25}
                    sx={{
                        width: "100%",
                        textAlign: "left",
                    }}
                >
                    {messageList.map((msg, index) => (
                        <Box
                            key={index}
                            sx={{
                                backgroundColor: "rgba(255, 49, 0, 0.10)",
                                border: "1px solid rgba(1, 36, 67, 0.12)",
                                borderRadius: "8px",
                                px: 1.4,
                                py: 1.1,
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1.2,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 7,
                                    height: 7,
                                    borderRadius: "50%",
                                    backgroundColor: "#FF3100",
                                    flexShrink: 0,
                                    mt: "0.4rem"
                                }}
                            />
                            <Typography
                                variant="body2"
                                fontWeight={600}
                                color="#012443"
                                sx={{ fontSize: "0.91rem", lineHeight: 1.4, wordBreak: "break-word" }}
                            >
                                {typeof msg === "string" ? msg : msg?.message}
                            </Typography>
                        </Box>
                    ))}
                </Stack>
            </DialogContent>

            <Divider sx={{ borderColor: "rgba(1, 36, 67, 0.12)" }} />

            <DialogActions
                style={{
                    padding: "16px 20px 20px 20px",
                    justifyContent: "flex-end"
                }}>
                <Button
                    variant="contained"
                    onClick={handleDismiss}
                    sx={{
                        backgroundColor: "#012443",
                        borderRadius: "8px",
                        px: 3,
                        minHeight: 42,
                        fontWeight: 600,
                        textTransform: "none",
                        fontSize: "0.9375rem",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#0A2540", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export { GlobalRequiredFieldsModal as GlobalRequiredFields };




